import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { ITimelineColumnProps } from "src/components/Planner/TimelineColumn/TimelineColumn";
import { UnstyledButton } from "src/ui";
import { Callout } from "@fluentui/react";
import TimelineLabelForm from "src/components/Planner/TimelineLabelForm/TimelineLabelForm";
import { localize } from "src/l10n";
import { CaptionBody, SmallBody } from "src/components/Text";
import { dayLangTags } from "../utils";

const TimelineColumnDay = (props: ITimelineColumnProps) => {
    const headerRef = React.useRef<HTMLDivElement>(null);

    const data = useMemo(() => {
        const m = moment(props.item.startMilliseconds);
        return {
            isThursday: m.isoWeekday() === 4,
            isSunday: m.isoWeekday() === 7,
            isFirstOfMonth: m.date() === 1,
            displayString: localize(dayLangTags[m.isoWeekday() - 1]) + " " + m.format("D MMM"),
            momentDate: m,
            isoWeekday: m.isoWeekday(),
            isActive: m.isSame(moment(), 'day')
        }
    }, [props.item.startMilliseconds]);

    const [displayCallout, setDisplayCallout] = useState(false);

    useEffect(() => {
        props.reportHeaderHeight(headerRef.current.clientHeight);
    }, [headerRef, props.displayLabelRow]);

    return (
        <div className="TimelineColumn day" style={{
            width: props.columnWidth
        }}>
            <div ref={headerRef}>
                <div
                    className={[
                        "header-column",
                        data.isSunday ? "border-right" : "",
                    ].filter(x => !!x).join(" ")}
                    style={{
                        height: 32,
                        width: props.columnWidth,
                    }}>
                    <SmallBody>{data.isThursday && (localize("Vecka") + " " + data.momentDate.isoWeek() + " " + data.momentDate.format("YYYY"))}</SmallBody>
                </div>
                {props.displayLabelRow && (
                    <UnstyledButton
                        className="header-column border-right label"
                        disabled={!props.rights.canEditLabels}
                        style={{
                            width: props.columnWidth
                        }}
                        onClick={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                    >
                        <CaptionBody>{props.label?.text}</CaptionBody>
                    </UnstyledButton>
                )}
                <UnstyledButton
                    id={"column-" + props.item.startMilliseconds}
                    disabled={!props.rights.canEditLabels}
                    className={[
                        "header-column",
                        "border-right",
                        (data.isActive ? " active" : "")
                    ].join(" ")}
                    style={{
                        width: props.columnWidth,
                        height: 36,
                    }}
                    onClick={() => {
                        setDisplayCallout(!displayCallout);
                    }}
                >
                    <div>
                        <SmallBody>{data.displayString}</SmallBody>
                    </div>
                </UnstyledButton>
                {displayCallout && (
                    <Callout
                        preventDismissOnResize
                        role="alertdialog"
                        gapSpace={0}
                        setInitialFocus
                        onDismiss={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                        className="users-selection"
                        target={"#column-" + props.item.startMilliseconds}
                    >
                        <TimelineLabelForm
                            date={new Date(props.item.startMilliseconds)}
                            onDone={() => {
                                setDisplayCallout(!displayCallout);
                            }}
                        />
                    </Callout>
                )}
            </div>
            <div className={[
                "border-right",
                "lane",
                "weekday-" + data.isoWeekday
            ].join(" ")} style={{
                width: props.columnWidth,
            }}></div>
        </div>
    )
}

export default TimelineColumnDay;
